export const TEXT_CONTENT = {
  PT_ARRIVAL_VS_PTS_COVERED: 'Pt Arrivals vs Pts Covered',
  PT_ARRIVAL_VS_PTS_COVERED_SUMMARY: 'Summary ( Pt Arrivals vs Pts Covered )',
  PT_ARRIVAL_VS_PTS_COVERED_DAILY_TOTAL_SUMMARY:
    'Daily Total Summary ( Pt Arrivals vs Pts Covered )',
  EDIT_FORCED_SHIFT_TIMES: 'Edit Forced Shift Times',
  FORCED_SHIFTS_DETAILS: 'Forced Shifts Details',
  VIEW_OR_EDIT_FORCED_SHIFT_TIMES: 'View / Edit Forced Shift Times',
  SHIFTS_DETAILS: 'Shifts Details',
  SHIFTS_DETAILS_SUMMARY: 'Summary ( Shifts Details )',
  SHIFTS_CASCADE: 'Shifts Cascade',
  SHIFTS_CASCADE_SUMMARY: 'Summary ( Shifts Cascade )',
  COMPARE_SHIFT_MAPS: 'Compare Shift Maps',
  SHIFT_MAP_OPTIONS: 'Shift Map Options',
  DOW_VOLUMES: 'DoW Volumes',
  TOLERANCE: 'Tolerance',
  DASHBOARD: 'Dashboard',
  RESET: 'Reset',
  GENERATE_NEW_SCHEDULE: 'Generate New Schedule',
  GENERATING_NEW_SCHEDULE: 'Generating New Schedule',
  APPLY_SCHEDULE: 'Apply New Schedule',
  MANAGE_SHIFT: 'Edit Shift Times',
  APP_PHYSICIAN_RATIO: 'APP : Physician Ratio',
  SURPLUS_OR_DEFICIT_BY_HOUR: 'Surplus / Deficit by Hour',
  HOUR: 'Hour',
  HOURS_SHORT: 'Hrs',
  DAY: 'Day',
  VOLUME: 'Volume',
  DOW: 'DoW',
  EXPORT_TO_PDF: 'Export To Pdf',
  STAFFING_GAP_SCORE: 'Staffing Gap Score',
  PTS_PER_CHR: 'Pts/cHr',
  NOTE: 'Note',
  TOTAL: 'Total',
  SELECT_A_FACILITY: 'Select a Facility',
  VIEW_SAVED: 'View Saved',
  SELECT_A_DAY: 'Select a Day',
  SELECT_A_PROVIDER_TYPE: 'Select a Provider Type',
  SELECT_A_SHIFT_LENGTH: 'Select a Shift Length',
  SHIFT_START: 'Shift Start',
  START: 'Start',
  END: 'End',
  IN: 'IN',
  OUT: 'OUT',
  SHIFT_END: 'Shift End',
  SHIFT_START_DATE_HOUR: 'Shift Start Date Hour',
  PROVIDER_TYPE: 'Provider Type',
  PROVIDER: 'Provider',
  SHIFT_ID: 'Shift Id',
  PHYSICIAN_PATIENT_ARRIVALS: 'Physician Patient Arrivals',
  APP_PATIENT_ARRIVALS: 'APP Patient Arrivals',
  PATIENTS_COVERED_WITH_SHIFT_MAP: 'Patients Covered With Shift Map',
  PATIENT_ARRIVALS: 'Patient Arrivals',
  PHYSICIAN_HOURS_SCHEDULED: 'Physician Hours Scheduled',
  APP_HOURS_SCHEDULED: 'APP Hours Scheduled',
  PATIENTS_PER_CORRECTED_HOUR: 'Patients Per Corrected Hour',
  SHIFT_LENGTH: 'Shift Length',
  LENGTH: 'Length',
  SHIFT_LENGTHS: 'Shift Lengths',
  PROVIDER_COUNT: 'Provider Count',
  COUNT: 'Count',
  TOTAL_PHYSICIAN_HOURS: 'Total Physician Hours',
  TOTAL_APP_HOURS: 'Total APP Hours',
  TOTAL_APP_PHY_HOURS: 'Total (APP + Physician) Hours',
  TOTAL_CORRECTED_APP_PHY_HRS: 'Total Corrected (Physician + Half APP) Hours',
  NO_SHIFT_MAP_OPTIONS: 'No Shift Map Options Available',
  NO_DATA_AVAILABLE: 'No Data Available',
  NO_ROWS_FOUND: 'No Rows Found',
  NO_FACILITIES_AVAILABLE: 'No Facilities Available',
  NOT_FOUND: 'Not Found',
  DOWNLOAD: 'Download',
  CLOSE: 'Close',
  DAY_OF_WEEK: 'Day of Week',
  ACTIONS: 'Actions',
  ADD_NEW_SHIFT: 'Add New Shift',
  DELETE: 'Delete',
  NEW: 'New',
  EDIT: 'ED',
  VERSION_NAME: 'Version Name',
  INPUT_PARAM_VERSION_UPDATED:
    'Input parameter version data updated with new set of data.',
  NEW_INPUT_PARAM_VERSION_ADDED:
    'New input parameter version added successfully.',
  INPUT_PARAM_SAVE_FAILED:
    'Something went wrong! Save operation failed. Please try again!',
};
export const SHIFT_LENGTHS = [8, 9, 10, 11, 12];
